import useGlobalPaymentDataSubscribe from './useGlobalPaymentDataSubscribe';
import useCreateGlobalPayment from './useCreateGlobalPayment';
import useDeleteGlobalPayment from './useDeleteGlobalPayment';
import useUpdateGlobalPayment from './useUpdateGlobalPayment';
import { useAppSelector } from './useReduxHooks';

function useGlobalPaymentCRUD() {
  const { hospitalId } = useAppSelector((state) => state.user);
  const { currentTabletID } = useAppSelector((state) => state.tabletId);

  const userId = hospitalId.toString();
  const tabletId = currentTabletID;

  const { paymentInfo, isLoading, error } = useGlobalPaymentDataSubscribe(
    userId,
    tabletId,
  );

  const createPaymentMutation = useCreateGlobalPayment(userId, tabletId);
  const deletePaymentMutation = useDeleteGlobalPayment(userId, tabletId);
  const updatePaymentMutation = useUpdateGlobalPayment(userId, tabletId);

  return {
    // 구독 데이터
    paymentInfo,
    isLoading,
    error,

    // 결제 정보 생성
    createPayment: createPaymentMutation.mutateAsync,
    isCreating: createPaymentMutation.isLoading,
    createError: createPaymentMutation.error,

    // 결제 정보 삭제
    deletePayment: deletePaymentMutation.mutateAsync,
    isDeleting: deletePaymentMutation.isLoading,
    deleteError: deletePaymentMutation.error,

    // 결제 정보 업데이트
    updatePayment: updatePaymentMutation.mutateAsync,
    isUpdating: updatePaymentMutation.isLoading,
    updateError: updatePaymentMutation.error,
  };
}

export default useGlobalPaymentCRUD;
